import { v4 as uuidv4 } from 'uuid';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { InfoCardList } from '../../../../vtex-apps/info-card-list/InfoCardList/default';

export default function BrandGroup() {
	return {
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
		componentGroup: 'BrandGroup',
		props: FlexLayoutRow({
			blockClass: 'flex-row__brand-group-2',
			mzTitle: 'MZ | Marcas',
			colSizing: 'auto',
		}).props,
		variables,
		childrenComponents: [
			FlexLayoutCol(
				{
					blockClass: 'flex-col-left__brand-group-2',
					width: { desktop: '70%', mobile: '30%' },
				},
				[
					RichText({
						textPosition: 'CENTER',
						text: 'Confira nossa seção de produtos 3M',
						blockClass: 'header-text__brand-group-2',
					}),
					InfoCardList({ infoCards }, [
						SliderLayout({
							label: 'slider',
							itemsPerPage: {
								desktop: 4,
								tablet: 3,
								phone: 1,
							},
							blockClass: 'slider__brand-group-2',
							fullWidth: true,
						}),
					]),
				],
			),
			FlexLayoutCol(
				{
					blockClass: 'flex-col-right__brand-group-2',
					width: {
						desktop: '30%',
						mobile: '100%',
					},
				},
				[
					Image({
						blockClass: 'right-image__brand-group-2',
						src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046148072-brand-group-img-left.png',

						link: {
							newTab: true,
							url: '/',
						},
					}),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--support-color-3', to: '--brand-group-2-background', name: 'Background' },
			{ from: '--white', to: '--brand-group-2-text-color', name: 'Text' },
			{ from: '--brand-color-primary-pure', to: '--brand-group-2-slider-color', name: 'Slider' },
			{ from: '--white', to: '--brand-group-2-slider-arrow-color', name: 'Arrow' },
			{ from: '--white', to: '--brand-group-2-dots-color', name: 'Dots' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--brand-group-2-image-radius', name: 'Image Border Radius' },
			{ from: '--border-radius-sm', to: '--brand-group-2-slider-radius', name: 'Slider Border Radius' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxl', to: '--brand-group-2-heading-fontsize', name: 'Heading' },
			{ from: '--font-size-xl', to: '--brand-group-2-heading-fontsize-m', name: 'Heading Mobile' },
			{ from: '--font-size-sm', to: '--brand-group-2-label-fontsize', name: 'Label' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--brand-group-2-heading-fw', name: 'Heading' },
			{ from: '--font-weight-700', to: '--brand-group-2-body-fw', name: 'Body' },
		],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--brand-group-2-fontfamily', name: 'Font Family' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxs', to: '--brand-group-2-dot-width', name: 'Dot Width' },
			{ from: '--spacing-xxs', to: '--brand-group-2-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--brand-group-2-dot-height', name: 'Dot Height' },
			{ from: '--spacing-nano', to: '--brand-group-2-dot-height-active', name: 'Dot Height Active' },
		],
	},
];

const infoCards = [
	{
		id: 'info-card-category-1',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046176744-brand-group-img-1.png',
		callToActionText: 'Linha Attest™',
		callToActionUrl: '/',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-2',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046176744-brand-group-img-1.png',
		callToActionText: 'Linha Coban™',
		callToActionUrl: '/',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-3',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046176744-brand-group-img-1.png',
		callToActionText: 'Linha Comply™',
		callToActionUrl: '/',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-4',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046176744-brand-group-img-1.png',
		callToActionText: 'Linha Cavilon™',
		callToActionUrl: '/',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-5',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046176744-brand-group-img-1.png',
		callToActionText: 'Clean-Trace™',
		callToActionUrl: '/',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-6',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046176744-brand-group-img-1.png',
		callToActionText: 'Tega Derm™',
		callToActionUrl: '/',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-2',
		textAlignment: 'center',
	},
];
